import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track"]
  static values = { interval: Number }

  connect() {
    this.slides = this.trackTarget.querySelectorAll(".carousel-item")
    this.currentIndex = 0
    this.start()
  }

  disconnect() {
    this.stop()
  }

  start() {
    this.stop()
    this.timer = setInterval(() => this.next(), this.intervalValue)
  }

  stop() {
    if (this.timer) clearInterval(this.timer)
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length
    this.scrollToCurrent()
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length
    this.scrollToCurrent()
    this.start()
  }

  goTo(event) {
    this.currentIndex = event.params.index
    this.scrollToCurrent()
  }

  scrollToCurrent() {
    const slide = this.slides[this.currentIndex]
    if (!slide) return

    this.trackTarget.scrollLeft = slide.offsetLeft - this.trackTarget.offsetLeft
  }
}
